import React from 'react';
import PairOfCards from '../../../../../components/PairOfCards';

export function Hand({ row }) {
  const cardsStr = row.cards.split('/');
  const cards = [
    {
      rank: cardsStr[0][0],
      suit: cardsStr[0][1]
    },
    {
      rank: cardsStr[1][0],
      suit: cardsStr[1][1]
    }
  ];

  return (
    <div className="hand">
      <PairOfCards cards={cards} />
    </div>
  );
}
